import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { StyledBlockAction, StyledInputBlock } from "../../styles/styledTabsForm";
import DialogModal from "../dialogModal/DialogModal";
import TwoFa from "../twoFa/TwoFa";

const FailTransactionButton = ({ id, type, setNotification, notification, fetch }) => {
  const { t } = useTranslation("clientsPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const handleRetryCallback = () => {
    axios.get("/api/" + type + "/retry-callback/" + id, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        setNotification({ ...notification, visible: true, type: "success", message: "Success fail transaction" });
        fetch();
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const handleFailTransaction = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.patch("/api/" + type + "/fail/" + id, {}, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        handleRetryCallback()
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("failTransaction.twoFa")}
        content={<TwoFa
          handleSubmit={handleFailTransaction}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        onSubmit={event => {
          event.preventDefault();
          setOpen(true);
        }}
      >
        <StyledBlockAction>
          <DefaultButton
            color="danger"
            type="submit"
          >
            Fail transaction
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default FailTransactionButton;